import React from 'react'
import arrowBtn from './../../UI/general/Icon_Show-Hide.svg'

//import { fichasData } from '../../data/fichas.data'
import { getCotizaData as cotizaData } from '../../helpers/strapi.helper';

interface Props {
  showInfo: boolean,
  optionsData: any,
  currentSelectedVista: number,
  currentEditionSelected: string
  handleShowVideo: (payload: boolean) => void
  showVideo: boolean,
  handleIsVideoOpened: (payload: boolean) => void
  handleQuotation: (payload: boolean) => void
  isQuotationOpened: boolean
  isPlayingAnimation: boolean
  handleShowPDF: (payload: boolean) => void
  enableInternalCotizaGlobally: boolean
  handleCloseAllMenus: () => void
}

interface State {
  isVideoActive: boolean
}

class Info extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {
      isVideoActive: false
    }
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
    if(this.props.showVideo !== prevProps.showVideo){
      this.setState({
        isVideoActive: this.props.showVideo
      })
    }
  }

  handleSelectOption = (payload: string) => {
    if(payload === 'ficha'){
      this.props.handleShowPDF(true)
      // var tempFichasData: any = fichasData()
      // const tempLink = document.createElement('a')
      // tempLink.href = tempFichasData[this.props.currentEditionSelected]
      // tempLink.download = 'ficha_tecnica.pdf'
      // tempLink.click()
    }
    if(payload === 'modelo'){
      this.props.handleShowVideo(true)
    }
    if(payload === 'video'){
      this.props.handleIsVideoOpened(true)
    }
    if(payload === 'cotiza'){
      if(this.props.enableInternalCotizaGlobally === true){
        this.props.handleQuotation(!this.props.isQuotationOpened)
      }else{
        var cotizaLink : any = cotizaData() //desactivar linea 4 si esto no se usa
        const tempLink = document.createElement('a')
        tempLink.href = cotizaLink[this.props.currentEditionSelected]
        tempLink.target = '_blank'
        tempLink.click()
      }
    }
    this.props.handleCloseAllMenus();
  }

  render(): React.ReactNode {
      return(
        <div className={!this.props.showInfo ? 'caracteristics-mobile-collapsed':'caracteristics-mobile-opened'}>

          {
            this.props.showInfo && 
            <div className='caracteristics-close-button' onClick={() => {this.props.handleCloseAllMenus()}}>
              <img src={arrowBtn} alt=''/>
            </div>
          }
          <div className='info-container-mobile'>
            <div className='info-container-title-mobile'>
              Información adicional 
            </div>
            <div className='info-options-general-container-mobile'>
            {
              Object.keys(this.props.optionsData).length > 0 ?
              <div className='options-general-container-mobile'>
                {
                  Object.keys(this.props.optionsData).map((option: any) => 
                  this.props.currentSelectedVista === 0 || option !== 'PRESENTACION' ?
                    <div className={`options-individual-container-mobile ${this.state.isVideoActive && this.props.optionsData[option].slug === 'modelo' ? 'color-selected' : ''} ${this.props.currentSelectedVista === 1 ? 'options-individual-container-mobile-4k-fix' : ''}`} onClick={
                    //<div className={this.state.isVideoActive && this.props.optionsData[option].slug === 'modelo' ? 'options-individual-container-mobile color-selected':'options-individual-container-mobile'} onClick={
                      () => { if(!this.props.isPlayingAnimation){
                        this.handleSelectOption(this.props.optionsData[option].slug)}}
                      }>
                      <img src={this.props.optionsData[option].Icon.default} alt=''/>
                      <div className='options-individual-name'>{this.props.optionsData[option].name}</div>
                    </div> : null
                  )
                }
              </div>:null 
            }
            </div>
          </div>

          <hr className='hr-caracteristicas-mobile hr-info'/>
        </div>
      )
  }
}

export default Info